import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function PaginationButton(_ref) {
  var onClick = _ref.onClick,
    page = _ref.page,
    title = _ref.title,
    disabled = _ref.disabled;
  return /*#__PURE__*/_jsx(Button, {
    theme: "stroke_secondary",
    disabled: disabled,
    onClick: function (_onClick) {
      function onClick() {
        return _onClick.apply(this, arguments);
      }
      onClick.toString = function () {
        return _onClick.toString();
      };
      return onClick;
    }(function () {
      return onClick(page);
    }),
    children: title
  });
}